export default __webpack_public_path__ + "static/ni-f9e76107da18e968224d9c17dc2d2681.svg";